














































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ThDropdownVue from "../components/ThDropdown.vue";
import GsnbStatusVue from "@/components/Gsnb/GsnbStatus.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import PayRollTaxVue from "../components/Payroll/PayRollTax.vue";
import ThDatePickerVue from "../components/ThDatePicker.vue";
import { DatePickerOptions } from "element-ui/types/date-picker";

@Component({
    ...mapGetters(["account"]),
    components: {
        "th-dropdown": ThDropdownVue,
        "th-date": ThDatePickerVue,
        "month-selector": MonthSelectorVue,
        "view-book": ViewAccountBookVue,
        "gsnb-status": GsnbStatusVue,
        "user-tree": AllUserTreeVue,
        "payroll-tax": PayRollTaxVue,
    },
})
export default class Business extends Vue {
    showTax: boolean = false;
    collectPeriod: string = this.$store.state.collectPeriod;
    clientList: any[] = [];
    records: any[] = [];
    inAccountBook(id: number) {
        Vue.axios.post(`accountbooks/` + id).then((res) => {
            this.$store.dispatch("changeAccounBook", res.data);
            this.$utils.setTaxType(res.data);
            this.$utils.getRemarks();
            this.$router.push("/gsnb");
        });
    }
    cjList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 111,
        },
        {
            text: "未采集",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "采集中",
            id: 3,
        },
        {
            text: "采集完成",
            id: 4,
        },
        {
            text: "采集失败",
            id: 5,
        },
        {
            text: "无需采集",
            id: 6,
        },
    ];
    qsList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未导入",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "取数完成",
            id: 4,
        },
        {
            text: "取数失败",
            id: 5,
        },
    ];
    sbList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未申报",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "申报中",
            id: 3,
        },
        {
            text: "申报通过",
            id: 4,
        },
        {
            text: "申报异常",
            id: 5,
        },
    ];
    height: string = "450px";
    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    // 人员组织
    accounterName: string = "所属人姓名";
    // 打开tree
    isTree: boolean = false;
    openTree() {
        this.isTree = !this.isTree;
    }
    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    tmp: UserTree | null = null;
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    isScope: boolean = false;
    handleNodeClick(data: Account) {
        this.isScope = true;
        if (data.name) this.accounterName = data.name;
        this.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.accounterNo = data.no;
        this.fetchData();
        this.isTree = false;
    }
    // 关闭tree
    closeTree() {
        this.isTree = false;
    }
    // 搜索
    searchQuery: string = "";
    startSearch() {
        this.currentPage = 1;
        this.fetchData();
    }
    // 日期筛选
    dateValue: string = ""
    chooseDate(date: string) {
        // let days = new Date(2022,2,0).getDate()
        this.dateValue = date
        this.$nextTick(() => {
            this.fetchData()
        })
    }
    batch: number = 0;
    showCheck: boolean = false;
    clickPer: boolean = false;
    delButton: string = "";
    perButton: string = "批量申报";
    showPerChange: boolean = false; //展示修改时间
    checkChange() { }
    // 批量切换
    batchList(command: string) {
        if (command === "批量采集") {
            this.batch = 2;
            this.gather(command);
        } else if (command === "批量申报") {
            this.batch = 1;
            this.showPerCheck(command);
        }
        else if (command === "批量取数") {
            this.batch = 3;
            this.qsCheck(command)
            // this.showPerCheck(command);
        } else if (command === "无需申报") {
            this.batch = 4;
            this.showPerCheck(command);
        }
        else if (command === "无需采集") {
            this.batch = 5;
            this.gathernone(command);
        }
    }
    qsCheck(command: string) {
        if (command === "批量取数") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量取数") {
            this.qsClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量取数";
            this.batch = 0;
        }
    }
    showPerCheck(command: string) {
        if (command === "批量申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量申报") {
            this.batchClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量申报";
            this.batch = 0;
        }
    }
    showPerChecknone(command: string) {
        if (command === "无需申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "无需申报") {
            this.batchClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "无需申报";
            this.batch = 0;
        }
    }
    async qsClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            const res = await Vue.axios.post(
                `gsnb/record/count`, { year: this.year.getFullYear(), ids: ids }
            )
            if (res.data.message) this.$message.success(res.data.message);
            this.fetchData();
        } else {
            this.$message.warning("请选择需要的账套");
        }
    }
    batchClick() {
        let arr = [];
        let ids = "";
        let state = 2
        if (this.batch === 1) state = 2
        else if (this.batch === 4) state = 6
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(
                    `gsnb/record/save`,
                    {
                        actionId: 702,
                        year: this.year.getFullYear(),
                        state: state,
                        ids: ids
                    }
                )
                .then((res) => {
                    if (res.data.message) this.$message.success(res.data.message);
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要的账套");
        }
    }
    // 批量采集
    gather(command: string) {
        if (command === "批量采集") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量采集") {
            this.gatherClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量采集";
            this.batch = 0;
        }
    }
    gathernone(command: string) {
        if (command === "无需采集") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "无需采集") {
            this.gatherClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "无需采集";
            this.batch = 0;
        }
    }
    gatherClick() {
        let arr = [];
        let ids = "";
        let state = 2
        if (this.batch === 2) state = 2
        else if (this.batch === 5) state = 6
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(
                    `gsnb/record/save`,
                    {
                        actionId: 701,
                        year: this.year.getFullYear(),
                        state: state,
                        ids: ids
                    }
                )
                .then((res) => {
                    if (res.data.message) this.$message.success(res.data.message);
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要的账套");
        }
    }
    // 下拉
    cjStatus: DataTable.DropItem = this.cjList[0];
    qsStatus: DataTable.DropItem = this.qsList[0];
    sbStatus: DataTable.DropItem = this.sbList[0]

    // 分页
    pageSize: number = 15;
    currentPage: number = 1;
    totalElements: number = 5;

    searchKey: string = "";
    // 是否展示check td
    isShowTd() {
        if (this.batch === 2 || this.batch === 1 || this.batch === 3 || this.batch === 4 || this.batch === 5 || this.batch === 6 || this.batch === 7 || this.batch === 8 || this.batch === 9) return true
        else return false
    }
    idCheckDisable(data: any) {
        if (this.batch === 1 || this.batch === 4) {
            if (data.reportState === 1 || data.reportState === 5) return false
            else return true
        }
        if (this.batch === 2 || this.batch === 5) {
            if (data.infoState === 1 || data.infoState === 5) return false
            else return true
        }
        // if (this.batch === 3) {
        //     if (data.countState === 1 || data.countState === 5) return false
        //     else return true
        // }
        return false
    }
    isShowCheck(data: any) {
        return true
        // if (this.batch === 7 && !data.isWarning && data.taxState === 4) return true;
        // else if (this.batch === 6 && data.isWarning) return true;
        // else return false;
    }
    // 获取社保期间
    getSbTime() {
        let time = this.$utils.dateAdd(new Date(), "m", -1)
        return this.$utils.simpleDateFormat(new Date(time), "m")
    }
    mounted() {
        if (this.$route.query.accounterNo) {
            this.accounterNo = this.$route.query.accounterNo;
        }
        this.fetchData();
    }
    chooseType() {
        this.currentPage = 1;
        this.fetchData();
    }
    closeTax() {
        this.showTax = false;
        // this.fetchData();
    }
    // 获取数据
    accounterNo: string = "";
    year: Date = this.$utils.strToDate((new Date().getFullYear() - 1).toString() + "0101")
    // pickerOptions初值为空对象,因为还未获取到限制的时间
    pickerOptions: DatePickerOptions = {};
    fetchData() {
        this.batch = 0;
        this.showCheck = false;
        let infoState = this.cjStatus.text === "全部" ? "" : this.cjStatus.id;
        let countState = this.qsStatus.text === "全部" ? "" : this.qsStatus.id;
        let reportState = this.sbStatus.text === "全部" ? "" : this.sbStatus.id;
        Vue.axios
            .post(
                `gsnb/record/list?accountId=${this.$store.state.account.id
                }&year=${this.year.getFullYear()}&page=${this.currentPage - 1}&size=${this.pageSize
                }&query=${this.searchQuery.trim()}&infoState=${infoState}&countState=${countState}&reportState=${reportState}&accounterNo=${this.accounterNo
                }`,
                {}
            )
            .then((res) => {
                this.clientList = res.data.data.content;
                this.totalElements = res.data.data.totalElements;
                this.$forceUpdate();
            });
    }
    // 转化时间
    getTime(date: any) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        let minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        return y + "-" + m + "-" + d;
    }
    getStatus(type: number, code: number) {
        if (type === 0) {
            if (code) {
                for (let i = 0; i < this.cjList.length; i++) {
                    if (this.cjList[i].id === code) return this.cjList[i].text;
                }
            } else return ""

        }
        else if (type === 1) {
            for (let i = 0; i < this.qsList.length; i++) {
                if (this.qsList[i].id === code) return this.qsList[i].text;
            }
        }
        else if (type === 2) {
            for (let i = 0; i < this.sbList.length; i++) {
                if (this.sbList[i].id === code) return this.sbList[i].text;
            }
        }
    }

    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.showCheck = false;
        this.batch = 0;
        this.fetchData();
    }

    /**
     * 客户列表checkbox选中的事件及逻辑处理
     */

    // 全选
    checkAll: boolean = false;
    changeAll(val: boolean) {
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.batch === 1 || this.batch === 4) {
                if (this.clientList[i].reportState === 1 || this.clientList[i].reportState === 5) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 2 || this.batch === 5) {
                if (this.clientList[i].infoState === 1 || this.clientList[i].infoState === 5) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 3) {
                this.$set(this.clientList[i], "checked", val);
            }
        }
    }
    // 监听全选
    @Watch("clientList", { deep: true })
    vouchersChange(val: Voucher.Voucher[]) {
        let all = true;
        let hasSelect = false;
        for (let i = 0; i < val.length; i++) {
            if (val[i].checked) {
                hasSelect = true;
            }
        }
        if (hasSelect) {
            this.delButton = "批量下载";
            if (this.clickPer) {
                if (this.batch === 1) {
                    this.perButton = "批量申报";
                } else if (this.batch == 2) {
                    this.perButton = "批量采集";
                } else if (this.batch == 3) {
                    this.perButton = "批量取数";
                } else if (this.batch == 4) {
                    this.perButton = "无需申报";
                } else if (this.batch == 5) {
                    this.perButton = "无需采集";
                }
            }
        } else this.perButton = "取消";
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                break;
            }
        }
        if (val.length === 0) all = false;
        this.checkAll = all;
    }
    showImport: boolean = false;
    id: number | null = null
    name: string = ""
    showReport(data: any) {
        if (data) {
            this.name = data.bookName
            this.id = data.accountBookId;
            this.showImport = true;
        }
    }
    closeImport() {
        this.fetchData();
        this.showImport = false;
    }
    // 修改客户
    showInfo: boolean = false;
    bookData: any | null = null;
    accountModify(data: any) {
        Vue.axios.get(`accountbooks/${data.accountBookId}`).then((res) => {
            this.bookData = res.data;
            this.showInfo = true;
        });
    }
    // 模态框 close
    closeInfo() {
        this.showInfo = false;
    }
    infoSuccess() {
        this.showInfo = false;
        this.fetchData();
    }
    purchase: number = 0;
    flowType: number = 1;
    statistics: any = [];
    total: any = {};
    // 选择类型
    isZeroPeriod: string | number = "";
    // 一键登录
    oneKey(id: number) {
        this.$utils.oneKeyLogin(id, this, "一键登录");
    }
}
